<template>
  <v-card outlined class="facet-editor pa-4">
    <h3 class="text-subtitle-1 font-weight-bold mb-3 theme-heading">
      Facet Weights
    </h3>
    <div class="text-caption theme-text-secondary mb-3">
      Adjust facet weights and importance to re-score results
    </div>

    <div
      v-for="(facet, index) in localFacets"
      :key="facet.name"
      class="facet-row mb-4"
    >
      <div class="d-flex align-center justify-space-between mb-1">
        <span class="text-body-2 font-weight-medium">{{ facet.name }}</span>
        <span class="text-caption font-weight-bold" :style="{ color: weightColor(facet.weight) }">
          {{ facet.weight.toFixed(1) }}x
        </span>
      </div>

      <v-slider
        v-model="localFacets[index].weight"
        :min="0"
        :max="2"
        :step="0.1"
        color="#007AFF"
        :track-color="$vuetify.theme.dark ? '#555' : '#E0E0E0'"
        thumb-label
        hide-details
        dense
        class="mb-2"
        @change="emitUpdate"
      />

      <v-select
        v-model="localFacets[index].importance"
        :items="importanceOptions"
        dense
        outlined
        hide-details
        class="importance-select"
        color="#007AFF"
        @change="emitUpdate"
      >
        <template v-slot:selection="{ item }">
          <v-chip x-small :color="importanceColor(item)" text-color="white">
            {{ item }}
          </v-chip>
        </template>
      </v-select>
    </div>

    <v-divider class="my-3" />

    <v-btn
      block
      color="#007AFF"
      dark
      small
      @click="$emit('rescore')"
    >
      <v-icon small left>mdi-refresh</v-icon>
      Re-score Results
    </v-btn>
  </v-card>
</template>

<script>
export default {
  name: "FacetEditor",
  props: {
    facets: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localFacets: this.facets.map((f) => ({ ...f })),
      importanceOptions: ["must-have", "primary", "nice-to-have"],
    };
  },
  watch: {
    facets: {
      deep: true,
      handler(newVal) {
        this.localFacets = newVal.map((f) => ({ ...f }));
      },
    },
  },
  methods: {
    emitUpdate() {
      this.$emit("update-facets", this.localFacets.map((f) => ({ ...f })));
    },
    weightColor(weight) {
      if (weight >= 1.5) return "#10B981";
      if (weight >= 0.8) return "#007AFF";
      if (weight >= 0.3) return "#F59E0B";
      return "#9E9E9E";
    },
    importanceColor(importance) {
      const colors = {
        "must-have": "#EF4444",
        "primary": "#007AFF",
        "nice-to-have": "#9E9E9E",
      };
      return colors[importance] || "#9E9E9E";
    },
  },
};
</script>

<style scoped>
.facet-row {
  padding: 8px;
  border-radius: 6px;
}
.v-application.theme--light .facet-row {
  background: #FAFAFA;
}
.v-application.theme--dark .facet-row {
  background: rgba(255, 255, 255, 0.05);
}
.importance-select {
  max-width: 200px;
}
.theme-text-secondary {
  color: #666;
}
.v-application.theme--dark .theme-text-secondary {
  color: #aaa;
}
</style>
